import { Injectable } from '@angular/core';
import { MemberToken } from '../../../libs/proto/mobile_pb';
import { BinaryWriter } from 'google-protobuf';

@Injectable({
  providedIn: 'root'
})
export class MemberTokenConversionService {

  constructor() { }

  ToStorage(req: MemberToken) {
    const w = new BinaryWriter();
    MemberToken.serializeBinaryToWriter( req, w);

    const abuf = w.getResultBuffer();
    return Array.from // if available
              ? Array.from(abuf) // use Array#from
              : abuf.map(v => v);
  }

  FromStorage(data: any, callback: (signinRequest: MemberToken, errorConvert: any) => void) {
    try {
      callback( MemberToken.deserializeBinary(data), null);
    } catch (error) {
      callback( null, error);
    }
  }
}
